const FETCHING = 'FETCHING';
export const FETCHING_DATA = `${FETCHING}_DATA`;
export const FETCHING_DATA_SUCCESS = `${FETCHING}_DATA_SUCCESS`;
export const FETCHING_DATA_FAILURE = `${FETCHING}_DATA_FAILURE`;



// WEBPACK FOOTER //
// ./src/constants.js